import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const postsManagementService = createApi({
  reducerPath: 'postsManagementService',
  baseQuery: baseQueryWithReauth,
  tagTypes: [],
  endpoints: ({ query }) => ({
    getDelevrablesistPostsManage: query({
      query: ({ jobId }) => {
        return {
          url: `/jobs/v1/operator/jobs/${jobId}/deliverables`,
        };
      },
    }),
    getClientInfoPostsManage: query({
      query: ({ jobId }) => {
        return {
          url: `/jobs/v1/operator/jobs/${jobId}/postActivities`,
        };
      },
    }),
    getTimerInfoPostsManage: query({
      query: ({ jobId }) => {
        return {
          url: `/jobs/v1/operator/jobs/${jobId}/counter`,
        };
      },
    }),
    getJobRequestsPostsManage: query({
      query: ({ jobId }) => {
        return {
          url: `/jobs/v1/operator/jobs/${jobId}/job-requests`,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDelevrablesistPostsManageQuery,
  useGetClientInfoPostsManageQuery,
  useGetTimerInfoPostsManageQuery,
  useGetJobRequestsPostsManageQuery,
} = postsManagementService;

